 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML03_CONTENTS from '@/components/html/03_Contents'
 import HTML04_PREFACE from '@/components/html/04_Preface'
 import HTML05_TRANSLATOR_S_NOTE from '@/components/html/05_Translator_s_Note'
 import HTML06_INTERVIEW from '@/components/html/06_Interview'
 import HTML07_PART_I__GENERALITIES from '@/components/html/07_PART_I__GENERALITIES'
 import HTML08_1__THE_LESSONS_OF_THE_MIDDLE_AGE from '@/components/html/08_1__The_Lessons_of_the_Middle_Age'
 import HTML09_2__THE_MEANING_AND_VALUE_OF_PHIL from '@/components/html/09_2__The_Meaning_and_Value_of_Phil'
 import HTML10_3__JUST_HOW_IS_ISLAMIC_PHILOSOPH from '@/components/html/10_3__Just_How_Is_Islamic_Philosoph'
 import HTML11_PART_II__COMMON_THEMES from '@/components/html/11_PART_II__COMMON_THEMES'
 import HTML12_4__IS_PHYSICS_INTERESTING__SOME from '@/components/html/12_4__Is_Physics_Interesting__Some'
 import HTML13_5__THE_FLESH__A_MEDIEVAL_MODEL_O from '@/components/html/13_5__The_Flesh__A_Medieval_Model_o'
 import HTML14_6__THE_DENIAL_OF_HUMANITY__ON_TH from '@/components/html/14_6__The_Denial_of_Humanity__On_th'
 import HTML15_PART_III__COMPARISONS from '@/components/html/15_PART_III__COMPARISONS'
 import HTML16_7__THREE_MUSLIM_VIEWS_OF_THE_CHR from '@/components/html/16_7__Three_Muslim_Views_of_the_Chr'
 import HTML17_8__THE_JIH_D_OF_THE_PHILOSOPHERS from '@/components/html/17_8__The_Jih_d_of_the_Philosophers'
 import HTML18_PART_IV__FILIATIONS from '@/components/html/18_PART_IV__FILIATIONS'
 import HTML19_9__INCLUSION_AND_DIGESTION__TWO from '@/components/html/19_9__Inclusion_and_Digestion__Two'
 import HTML20_10__THE_INTERPRETER__REFLECTIONS from '@/components/html/20_10__The_Interpreter__Reflections'
 import HTML21_11__THE_ENTRY_OF_ARISTOTLE_IN_EU from '@/components/html/21_11__The_Entry_of_Aristotle_in_Eu'
 import HTML22_12__THE_EXTRA_EUROPEAN_SOURCES_O from '@/components/html/22_12__The_Extra_European_Sources_o'
 import HTML23_PART_V__PRICKED_BALLOONS from '@/components/html/23_PART_V__PRICKED_BALLOONS'
 import HTML24_13__SOME_MEDITERRANEAN_MYTHS from '@/components/html/24_13__Some_Mediterranean_Myths'
 import HTML25_14__WAS_THERE_ANY_DIALOGUE_BETWE from '@/components/html/25_14__Was_There_Any_Dialogue_betwe'
 import HTML26_15__GEOCENTRISM_AS_THE_HUMILIATI from '@/components/html/26_15__Geocentrism_as_the_Humiliati'
 import HTML27_16__WAS_AVERROES_A__GOOD_GUY from '@/components/html/27_16__Was_Averroes_a__Good_Guy'
 import HTML28_APPENDIX__ORIGINAL_TEXTS from '@/components/html/28_Appendix__Original_Texts'
 import HTML29_NOTES from '@/components/html/29_Notes'
 import HTML30_INDEX from '@/components/html/30_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/03_Contents",
 			"name" : "html/03_Contents",
 			"component" : HTML03_CONTENTS
 		},
 		{
 			"path" : "/html/04_Preface",
 			"name" : "html/04_Preface",
 			"component" : HTML04_PREFACE
 		},
 		{
 			"path" : "/html/05_Translator_s_Note",
 			"name" : "html/05_Translator_s_Note",
 			"component" : HTML05_TRANSLATOR_S_NOTE
 		},
 		{
 			"path" : "/html/06_Interview",
 			"name" : "html/06_Interview",
 			"component" : HTML06_INTERVIEW
 		},
 		{
 			"path" : "/html/07_PART_I__GENERALITIES",
 			"name" : "html/07_PART_I__GENERALITIES",
 			"component" : HTML07_PART_I__GENERALITIES
 		},
 		{
 			"path" : "/html/08_1__The_Lessons_of_the_Middle_Age",
 			"name" : "html/08_1__The_Lessons_of_the_Middle_Age",
 			"component" : HTML08_1__THE_LESSONS_OF_THE_MIDDLE_AGE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js